import { parseFullName } from 'parse-full-name';
class Analytics {
  constructor(mixpanel, smartlook, marketo) {
    this.mixpanel = mixpanel;
    this.smartlook = smartlook;
    this.marketo = marketo;
  }

  login(userId) {
    this.mixpanel.identify(userId);
    this.mixpanel.people.set_once({
      enigma_id: userId,
      $created: new Date(),
    });
    this.smartlook('identify', userId);
  }

  registerUser({ email, fullName, userId }) {
    this.mixpanel.alias(userId);

    this.mixpanel.people.set_once({
      enigma_id: userId,
      $created: new Date(),
    });

    this.mixpanel.people.set({
      $email: email,
      $first_name: fullName,
    });
    this.smartlook('identify', userId, { email: email, name: fullName });

    if (process.env.REACT_APP_MUNCHKIN_ID) {
      const name = parseFullName(fullName);

      const marketoForm = this.marketo.allForms()[0];
      marketoForm.addHiddenFields({
        Email: email,
        FirstName: name.first,
        LastName: name.last,
      });
      marketoForm.submit();
    }
  }

  track(event, properties) {
    // this.mixpanel.track(event, properties);
    this.smartlook('track', event, properties);
  }

  logout() {
    this.mixpanel.reset();
  }
}

const mockAnalytics = {
  login: () => {},
  logout: () => {},
  mixpanel: {
    people: {
      set: () => {},
    },
    register: () => {},
  },
  registerUser: () => {},
  track: () => {},
};

export default window.Cypress
  ? mockAnalytics
  : new Analytics(window.mixpanel, window.smartlook, window.marketo);
